// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__uBHOO","col":"styles_col__3iYYI","fulfillmentStatus":"styles_fulfillmentStatus__EzRlJ","emailCol":"styles_emailCol__1wAyl"};